<script setup lang="ts">
import { provide, watch, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import ProjectExecution from '@/components/projects/execution/ProjectExecution.vue'

const route = useRoute()

// These props are set by the router
interface Props {
  documentId?: string | null | undefined
  taskId?: string | null | undefined
  lateralTab?: string | null | undefined
}

const props = withDefaults(defineProps<Props>(), {})

console.log(
  'Project page - documentId: ',
  props.documentId,
  ' - taskId: ',
  props.taskId,
  '- lateralTab: ',
  props.lateralTab,
)

const documentId = ref(props.documentId)
const taskId = ref(props.taskId)
const lateralTab = ref(props.lateralTab)

provide('documentId', documentId)
provide('taskId', taskId)
provide('lateralTab', lateralTab)

watch(
  () => props.documentId,
  () => {
    console.log(
      'Project page - documentId: ',
      props.documentId,
      ' - taskId: ',
      props.taskId,
      '- lateralTab: ',
      props.lateralTab,
    )
    documentId.value = props.documentId
  },
)

watch(
  () => props.taskId,
  () => {
    console.log(
      'Project page - documentId: ',
      props.documentId,
      ' - taskId: ',
      props.taskId,
      '- lateralTab: ',
      props.lateralTab,
    )
    taskId.value = props.taskId

    if (taskId.value) {
      console.log('task selected - setting lateral tab')
      lateralTab.value = 'details'
    }
  },
)

watch(
  () => props.lateralTab,
  () => {
    console.log(
      'Project page - documentId: ',
      props.documentId,
      ' - taskId: ',
      props.taskId,
      '- lateralTab: ',
      props.lateralTab,
    )
    lateralTab.value = props.lateralTab
  },
)

onMounted(() => {
  console.log('Project page - onMounted')
})
</script>

<template>
  <q-page class="full-height">
    <!-- https://stackoverflow.com/questions/73430291/vue-3-use-suspense-again-when-data-have-to-be-refreshed -->
    <Suspense timeout="0">
      <template #default>
        <!-- https://michaelnthiessen.com/force-re-render/ -->
        <ProjectExecution :project-id="route.params.projectId.toString()" :key="route.params.projectId.toString()">
        </ProjectExecution>
      </template>
      <template #fallback>
        <div class="bg-transparent">
          <div class="row items-center" style="height: 74px">
            <q-skeleton animation="blink" type="text" class="q-ml-md" style="width: 30%; height: 42px" />
            <q-skeleton class="q-ml-sm" type="circle" size="32px"> </q-skeleton>
            <q-skeleton class="q-ml-sm" type="circle" size="32px"> </q-skeleton>
          </div>
          <div class="row items-center q-mb-sm">
            <q-skeleton type="QBtn" class="q-ml-md" style="width: 150px" />
            <q-skeleton type="QBtn" class="q-ml-sm" style="width: 150px" />
            <q-skeleton class="q-ml-sm" type="circle" size="32px"> </q-skeleton>
            <q-skeleton class="q-ml-sm" type="circle" size="32px"> </q-skeleton>
          </div>
          <q-separator />
          <div class="full-width row justify-center items-center" style="height: 70vh">
            <q-spinner size="50px" color="grey" />
          </div>
        </div>
      </template>
    </Suspense>
  </q-page>
</template>
